import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../utils/i18n';
import HomepageFeaturedRestaurantTile from '../HomepageFeaturedRestaurantTile';
import styles from './styles.scss';

export default function HomepageFeaturedRestaurants({ restaurants, onClick }) {
  if (restaurants.length === 0) return null;

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <h2 className={styles['list-title']}>{i18n.gettext('Loved by you, delivered by us')}</h2>
        <ul className={styles.list}>
          {restaurants.map((restaurant) => (
            <HomepageFeaturedRestaurantTile key={restaurant.id} onClick={onClick} {...restaurant} />
          ))}
        </ul>
      </div>
    </div>
  );
}

HomepageFeaturedRestaurants.propTypes = {
  restaurants: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      image: PropTypes.string,
    }),
  ).isRequired,
  onClick: PropTypes.func,
};

HomepageFeaturedRestaurants.defaultProps = {
  onClick: undefined,
};
